module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"head":{"meta":{"description":"TODO:このページの説明文をここに記述する(※Googleの検索結果に表示されるのでよく考える事!)"}},"date_of_event":"開催日","deadl.info-tableine":"申込締切","time_zone":"時間帯","location":"場所","details":"内容","holding_method":"開催方法","venue":{"type_face_to_face":"会場","type_remote":"WEB","type_both":"会場＋WEB"},"head_office":"本社"}}')
  delete Component.options._Ctor
}
